/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Reason why a restore method is not available for a snapshot.
*/
export enum RestoreMethodAvailabilityReason {
  RESTORE_METHOD_NOT_SPECIFIED = 'RESTORE_METHOD_NOT_SPECIFIED',
  RESTORE_METHOD_HAS_LSI = 'RESTORE_METHOD_HAS_LSI',
  RESTORE_METHOD_SIZE_LIMIT = 'RESTORE_METHOD_SIZE_LIMIT'
}
